import Axios from "../../api/Axios";
const BASE_URL = "RewardsAndRebateBook/";

export const EndpointSalesRNR = {
    GetCastrolQuarter: "GetCastrolQuarter",
    GetScheme: "GetScheme",
    GetAllDBActivityData: "GetAllDBActivityData",
    DownloadExcel: "DownloadExcel",
    GetAllDBActivityDetailData: "GetAllDBActivityDetailData",
    DeleteCustDetailsData: "DeleteCustDetailsData",
    Save: "Save",
    GetClosureDate : "GetClosureDate",
    // TODO: confirm actual route/params with backend once the New Template endpoint is finalized
    GetTemplateId: "GetTemplateId"
};
export const createAPIEndpointRNR = () => {
    return { 
        get: (Endpoint) => Axios.get(BASE_URL + Endpoint),
        post: (Endpoint, data) => Axios.post(BASE_URL + Endpoint, data),
    };

};
